
export interface TwoPosState {
  manualControls?: boolean;
  inputValue?: number;
  outputValue?: boolean;
  setPoint?: number;
  step?: number;
  min?: number;
  max?: number;
  hysteresis?: number;
  mode?: 'auto' | 'on' | 'off';
}
